export const langDropdown = function() {
	const langSwitcher = document.querySelector('.header__lang-dropdown-current'),
		  langContainer = document.querySelector('.header__lang-dropdown-list'),
		  langDropdownCloseBtn = document.querySelector('[data-mobile="lang-close"]'),
		  userBtn = document.querySelector('.header__user-dropdown-info'),
		  body = document.querySelector('body');
	if (!langSwitcher) return;
	langContainer.addEventListener('click', function(e) {
		e.stopPropagation();
	});

	langSwitcher.addEventListener('click', function(e) {
		e.stopPropagation();
		langSwitcher.classList.toggle('header__lang-dropdown-current--active');
		if (userBtn) {
			userBtn.classList.remove('header__user-dropdown-info--open');
		}
	});

	langDropdownCloseBtn.addEventListener('click', function(e) {
		langSwitcher.classList.remove('header__lang-dropdown-current--active');
	});

	body.addEventListener('click', (e)=> {
		langSwitcher.classList.remove('header__lang-dropdown-current--active');
	});
}
